/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Insights({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17" {...props}><g clipPath="url(#Insights_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M8.25.9a5.6 5.6 0 0 0-2.6 10.561V12.5c0 .567.295 1.065.74 1.35v.85a1.1 1.1 0 0 0 1.1 1.1h1.52a1.1 1.1 0 0 0 1.1-1.1v-.85c.445-.285.74-.783.74-1.35v-1.039A5.6 5.6 0 0 0 8.25.9m-.66 13.7v-.5h1.32v.5zM3.85 6.5a4.4 4.4 0 1 1 6.16 4.034.6.6 0 0 0-.36.55V12.5a.4.4 0 0 1-.4.4h-2a.4.4 0 0 1-.4-.4v-1.416a.6.6 0 0 0-.36-.55A4.4 4.4 0 0 1 3.85 6.5m5-.875a.6.6 0 0 0-1.2 0V7.5a.6.6 0 1 0 1.2 0zm-2.518.4a.6.6 0 0 1 .6.6V7.5a.6.6 0 1 1-1.2 0v-.875a.6.6 0 0 1 .6-.6m4.436-1.4a.6.6 0 0 0-1.2 0V7.5a.6.6 0 0 0 1.2 0z" clipRule="evenodd" /></g><defs><clipPath id="Insights_svg__a"><path fill="#fff" d="M.25.5h16v16h-16z" /></clipPath></defs></svg>;
}
;